import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../components/ui/breadcrumb';
import { SemanticLayerViewToggle, type SemanticLayerViewMode } from '../components/ViewModeToggle';

export default function SemanticLayer() {
  const navigate = useNavigate();
  const location = useLocation();

  const viewMode: SemanticLayerViewMode = location.pathname.includes('/diagram') ? 'diagram' : 'glossary';
  const subPageLabel = viewMode === 'diagram' ? 'Diagram' : 'Glossary';

  const handleViewModeChange = (mode: SemanticLayerViewMode) => {
    navigate(`/semantic-layer/${mode}`);
  };

  return (
    <div className="w-full flex flex-col bg-background overflow-hidden" style={{ height: 'calc(100vh)' }}>
      {/* Top Bar */}
      <div className="flex items-center justify-between w-full px-6 py-4 border-b border-border bg-background flex-shrink-0 z-10">
        <div className="flex flex-col gap-2 flex-1 min-w-0">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/semantic-layer">Semantic Layer</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>{subPageLabel}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
          <h1 className="text-xl font-semibold text-foreground">Semantic Layer {subPageLabel}</h1>
        </div>
        <div className="flex items-center gap-4">
          <SemanticLayerViewToggle value={viewMode} onChange={handleViewModeChange} />
        </div>
      </div>
      {/* Content */}
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}
